import { ShoppingCart, X } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";
import { Button } from "@/app/components/button";

interface CartToastProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToCart: () => void;
  productName: string;
}

export function CartToast({ isOpen, onClose, onGoToCart, productName }: CartToastProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/20 z-50"
          />
          
          {/* Toast */}
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 z-50 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8 pb-6"
          >
            <div className="bg-card border border-border rounded-2xl shadow-2xl overflow-hidden">
              {/* Header */}
              <div className="bg-primary p-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <ShoppingCart className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white">
                      Adicionado ao Carrinho!
                    </h3>
                    <p className="text-xs text-white/80">
                      Produto salvo com sucesso
                    </p>
                  </div>
                </div>
                <button
                  onClick={onClose}
                  className="p-2 hover:bg-white/10 rounded-lg transition-colors"
                >
                  <X className="w-5 h-5 text-white" />
                </button>
              </div>

              {/* Content */}
              <div className="p-4">
                <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
                  {productName === "__OFFER__" ? (
                    <span className="font-medium text-foreground">Sua oferta foi adicionada ao carrinho</span>
                  ) : (
                    <>
                      <span className="font-medium text-foreground">{productName}</span> foi adicionado ao seu carrinho
                    </>
                  )}
                </p>

                {/* Actions */}
                <div className="flex flex-col gap-2">
                  <Button
                    onClick={onGoToCart}
                    className="w-full"
                    size="lg"
                  >
                    <ShoppingCart className="w-4 h-4 mr-2" />
                    Ir para o Carrinho
                  </Button>
                  <Button
                    onClick={onClose}
                    variant="outline"
                    className="w-full"
                    size="lg"
                  >
                    Continuar Comprando
                  </Button>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
